module.exports = __webpack_public_path__ + "img/11.ac74e78a.png";